const routes = [
  {
    path: '/seminar',
    name: 'seminar',
    meta: {
      title: 'VLAMS - Seminar'
    },
    component: () => import('@/views/Event.vue')
  },
  {
    path: '/seminar/:id',
    name: 'seminar-detail',
    component: () => import('@/components/eventV2/EventDetail.vue')
  },
  {
    path: '/event-dashboard',
    name: 'event-dashboard',
    meta: {
      title: 'VLAMS - Event-Dashboard'
    },
    component: () => import('@/views/EventDashboard.vue')
  }
]

export default routes
